import { render, staticRenderFns } from "./customCatalogComponent.vue?vue&type=template&id=6a465072&scoped=true&"
import script from "./customCatalogComponent.vue?vue&type=script&lang=js&"
export * from "./customCatalogComponent.vue?vue&type=script&lang=js&"
import style0 from "./customCatalogComponent.vue?vue&type=style&index=0&id=6a465072&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a465072",
  null
  
)

export default component.exports